import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { TableBox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { useResponseHandler } from '../../common/auth';
import { useDataTable } from '../../common/hooks';
import { TitlePage } from '../../components/TitlePage/TitlePage'
import useGeneralStore from '../../store/general';
import { ModalCreateCampaignFromRules } from './Modal/ModalCreateCampaignFromRules';
import "./Rules.scss"


const Rules = ({ }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

    // Таблица
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading } = setTableFuncs;

    // Modal
    const [isModal, setIsModal] = useState(false)
    const [currentСampaign, setCurrentСampaign] = useState(null)


    const contextMenuArr = [
        {
            label: 'Удалить',
            onClick: (e) => {
                fetchDeleteStrategy(e?.id)
            }
        },
    ];

    // Таблица
    const fetchTableData = (params, abortController = new AbortController()) => {
        setLoading(true);

        let sort, filtersParam;
        if (params) {
            [sort, filtersParam] = params;
        }

        const url = `https://apps0.ecomru.ru:4420/api/v1/marketing/action/seller/strategy/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''
            }`;

        const body = JSON.stringify({
            filters: filtersParam,
            page: paginatorRef.current.page,
            limit: paginatorRef.current.limit
        });

        fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    };

    // Удаление стратегии
    const fetchDeleteStrategy = (id) => {
        let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then(handleTableResponse)
            .then(setTimeout(() => fetchTableData(), 100))
            .catch(handleRequestError);
    }

    // Изменение статуса стратегии
    const fetchChangeStatusStrategy = (status, id) => {
        let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${id}/status`

        const body = JSON.stringify({
            is_active: !status
        })

        fetch(url, { method: 'PATCH', headers, body })
            .then(handleTableResponse)
            .then(setTimeout(() => fetchTableData(), 1000))
            .catch(handleRequestError);
    }

    const handleCheck = (data) => {
        fetchChangeStatusStrategy(data?.['Активна']?.[0], data?.['Активна']?.[1]);
    };

    useEffect(() => {
        if (!isModal) {
            const abortController = new AbortController()
            setTimeout(() => fetchTableData([], abortController), 500)
            return () => abortController.abort()
        }
    }, [isModal]);

    // Получение всех параметров стратегии
    const fetchGetStrategyInfo = (id) => {
        let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${id}`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => {
                setCurrentСampaign(json)
                setIsModal(true)
            })
           .catch(handleRequestError);
    }

    const onActionHandler = (e) => {
        const uid = e?.['id']
        fetchGetStrategyInfo(uid)
    }

    return (
        <>
            {isModal && <ModalCreateCampaignFromRules
                setIsModal={(e) => setIsModal(e)}
                currentСampaign={currentСampaign}
                setCurrentСampaign={setCurrentСampaign}
            />}

            <div className='rules'>
                <TitlePage
                    title='Стратегии'
                />

                <TableBox
                    {...tableProps}
                    fetchCallback={fetchTableData}
                    ref={paginatorRef}
                    paginator={true}
                    child={
                        <ButtonBasic
                            onClick={(e) => setIsModal(true)}
                            green
                            text='Cоздать стратегию'
                            size='32px'
                        />
                    }
                    onAction={onActionHandler}
                    contextMenuArr={contextMenuArr}
                    onToggle={handleCheck}
                />
            </div>
        </>
    )
}

export { Rules }